<template>
  <div class="form-group row mt-4">

    <div class="col-12 mb-4">

      <div class="box-shadow">

        <div class="choose-input-block" v-if="protocol.masteringCondition">
          <h3 class="title-block">{{'protocol.condition_mastered_prop' | trans}}</h3>

          <input id="condition_procent_mastering"
                 ref="condition_procent_mastering"
                 min=80
                 max=1000
                 type="number"
                 v-on:keydown="changeNumber"
                 name="condition_procent_mastering"
                 :class="{'is-invalid': errors.has('condition_procent_mastering')}"
                 v-model=protocol.masteringCondition.ratio
                 v-validate="'min_value:80|max_value:100|numeric'"
                 data-vv-validate-on="none"
                 :data-vv-as="'protocol.condition_procent' | trans"/>% {{'protocol.percent_reaction' | trans }}

          <input id="condition_session"
                 ref="condition_session"
                 min=1
                 class="ml-2"
                 type="number"
                 v-on:keydown="changeNumber"
                 name="condition_session"
                 :class="{'is-invalid': errors.has('condition_session')}"
                 v-model=protocol.masteringCondition.sessionCount
                 v-validate="'min_value:1|max_value:10|numeric'"
                 data-vv-validate-on="none"
                 :data-vv-as="'protocol.condition_trial' | trans"/>
          {{'protocol.condition_trial' | trans }}
          <input id="condition_trial"
                 ref="condition_trial"
                 min=1
                 class="ml-2"
                 type="number"
                 v-on:keydown="changeNumber"
                 name="condition_trial"
                 :class="{'is-invalid': errors.has('condition_trial')}"
                 v-model=protocol.masteringCondition.trialCount
                 v-validate="'min_value:1|max_value:10|numeric'"
                 data-vv-validate-on="none"
                 :data-vv-as="'protocol.condition_session' | trans"/>
          {{'protocol.condition_session' | trans }}
        </div>
        <span class="invalid-feedback invalid"
              v-if="errors.has('condition_procent_mastering')">
                              <strong>{{errors.first('condition_procent_mastering')}}  </strong>
                        </span>
        <span class="invalid-feedback invalid"
              v-if="errors.has('condition_session')">
                              <strong>{{errors.first('condition_session')}}  </strong>
                        </span>
        <span class="invalid-feedback invalid"
              v-if="errors.has('condition_trial')">
                              <strong>{{errors.first('condition_trial')}}  </strong>
                        </span>
      </div>

    </div>

    <div class="col-md-12">
      <h4 class="row-title">{{'protocol.listCategories' | trans}}</h4>
    </div>

    <div class="col-12">

      <div v-for="(category, key) in protocol.categories" class="alert-secondary dragging-block">
        <div class="form-group row dragging">
          <div class="col-md-12 text-right" v-if="category.masteringPercent">
            <span class="mr-md-2">{{category.masteringPercent}}%</span>
          </div>
        </div>
        <div class="form-group row dragging mb-4">
          <div class="col-md-8 col-12">
            <mdc-textfield type="text"
                           :ref="'category_' + key"
                           :name="'category_' + key"
                           :label="'protocol.describeCategory', {number: key + 1} | trans"
                           class="required"
                           :class="{'is-invalid': errors.has('category_' + key)}"
                           v-validate="'required|max:1000|unique_category'"
                           v-model="category.title"
                           data-vv-validate-on="none"
                           :data-vv-as="'protocol.describeCategory', {number: key + 1} | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('category_' + key)">
                <strong>{{ errors.first('category_' + key) }}</strong>
            </span>
          </div>
          <div class="col-md-4 col-12">
            <button type="button"
                    v-if="category.typeId == 1"
                    :disabled="protocol.categories.length === 2 || protocol.categories.length > 10"
                    class="btn btn-link secondary-link btn-sm"
                    @click.prevent="removeCategory(category.uuid)">
              {{'protocol.deleteCategory'  | trans}}
            </button>
          </div>
        </div>

        <div class="form-group row dragging" v-for="(task, taskKey) in category.tasks">

          <div class="col-md-7 col-11 offset-1">
            <mdc-textfield type="text"
                           :ref="'task_' + key + '_' + taskKey"
                           :name="'task_' + key + '_' + taskKey"
                           :label="'protocol.describeProperty' | trans"
                           class="required"
                           :class="{'is-invalid': errors.has('task_' + key + '_' + taskKey)}"
                           v-validate="'required|max:1000|unique_properties'"
                           v-model="task.description"
                           data-vv-validate-on="none"
                           :data-vv-as="'protocol.describeProperty' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('task_' + key + '_' + taskKey)">
                <strong>{{ errors.first('task_' + key + '_' + taskKey) }}</strong>
            </span>
          </div>
          <div class="col-md-4 col-11 offset-1 offset-md-0">
            <button type="button"
                    :disabled="category.tasks.length === 1 || category.tasks.length > 20"
                    class="btn btn-link secondary-link btn-sm mt-2"
                    @click.prevent="removePropertyPopup(category.uuid, task.uuid)">
              {{'protocol.deleteProperty'  | trans}}
            </button>
          </div>

        </div>

        <div class="form-group row dragging">
          <div class="col-md-12 mt-2">
            <button type="button"
                    class="btn btn-info"
                    :disabled="category.tasks.length >= 20"
                    @click.prevent="addProperty(category.uuid, category.id)">
              {{'protocol.addProperty' | trans}}
            </button>
          </div>
        </div>

      </div>


      <div class="form-group row dragging">
        <div class="col-md-12 mt-4">
          <button type="button"
                  :disabled="!protocol.stages.length || protocol.categories.length > 9"
                  class="btn btn-info"
                  @click.prevent="addCategory()">
            {{'protocol.addCategory' | trans}}
          </button>
        </div>
      </div>

    </div>

    <div class="col-12">
      <div class="alert alert-secondary mt-2">
        <div class="form-group row">
          <div class="col-md-12">
            <h4 class="row-title">{{'protocol.listCategories' | trans}}</h4>
          </div>
          

          <div class="tasks col-md-12" id="tasks" v-if="protocol.categories">

            <table class="table table-sm mb-0" v-for="(category, index) in protocol.categories" :key="category.globalUuid">
              <thead :class="{'visibility-collapse' : index !== 0}">
              <tr>
                <th>{{'protocol.nameCategoryProperty' | trans}}</th>
                <th>{{'protocol.show_on_level' | trans}}</th>
                <th v-if="(isCurator || isBCBA) && protocol.assigneeId">{{'protocol.master' | trans}}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="table-secondary">
                <td class="name-field">
                  <strong>{{category.title}}</strong>
                </td>
                <td class="table-actions">
                  <mdc-checkbox v-model="category.active" @change="changeActiveCategory(category)"/>
                </td>
                <td class="table-actions" v-if="(isCurator || isBCBA) && protocol.assigneeId">
                </td>
              </tr>
              <tr v-for="task in category.tasks" :key="task.uuid">
                <td class="pl-4">{{task.description}}</td>
                <td class="table-actions"><mdc-checkbox v-model="task.active" @change="changeActiveTask(category, task)"/></td>
                <td v-if="(isCurator || isBCBA) && protocol.assigneeId">
                  <mdc-checkbox :disabled="!task.active" v-model="task.mastered" @change="masteredTask(task)"/>
                </td>
              </tr>
              </tbody>

            </table>

          </div>

          <div class="col-12" v-if="protocol.categories && !protocol.categories.length">
            {{'protocol.no_list_category' | trans}}
          </div>
          <!----------- tasks ------------------->
        </div>
      </div>
    </div>

    <div v-if="isModalAcceptPopup">
      <mdc-dialog v-model="isModalAcceptPopup"
                  :title="'protocol.confirm_delete_property' | trans"
                  :accept="'buttons.continue' | trans"
                  :cancel="'user.cancel' | trans"
                  @accept="removeProperty(currentCategoryUuid, currentTaskUuid)"
                  @cancel="cancel">

      </mdc-dialog>
    </div>

    <div v-if="isModalAcceptPopupCategory">
      <mdc-dialog v-model="isModalAcceptPopupCategory"
                  :title="'protocol.confirm_delete_category' | trans"
                  :accept="'buttons.continue' | trans"
                  :cancel="'user.cancel' | trans"
                  @accept="removeCategory(currentCategoryUuid)"
                  @cancel="cancel">

      </mdc-dialog>
    </div>




  </div>

</template>

<script>
  import {mapGetters} from 'vuex';
  import Hints from '../../protocols/components/Hints';
  import map from 'lodash/map';
  import forIn from 'lodash/forIn';
  import filter from 'lodash/filter';
  import findIndex from 'lodash/findIndex';
  import remove from 'lodash/remove';
  import trim from 'lodash/trim';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import lang from '../../../lang/translator';

  export default {
    props: {
      'protocol': {
        type: Object
      },
      teachingMethod:{
        type: Object
      }

    },

    components: {Hints},

    data() {
      return {
        isAllTasksEnabled: false,
        isModalAcceptPopup: false,
        currentCategoryUuid: null,
        currentTaskUuid: null,
        isModalAcceptPopupCategory: false
      };
    },

    computed: {
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
      ]),

    },

    inject: ["parentValidator"],

    created() {

      this.$validator = this.parentValidator;

      this.$validator.extend('unique_category', {
        getMessage: attribute => lang.get('validation.unique_categories',{attribute}),
        validate: async (category) => {

          let valid;
          let unique = 0;

          forIn(this.protocol.categories, function(item) {
            if (trim(item.title) === trim(category)) {
              unique++;
            }
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });

      this.$validator.extend('unique_properties', {
        getMessage: attribute => lang.get('validation.unique_properties',{attribute}),
        validate: async (property) => {

          let valid;
          let unique = 0;

          forIn(this.protocol.categories, function(item) {
            forIn(item.tasks, function(task) {
              if (trim(task.description) === trim(property)) {
                unique++;
              }
            });
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });

      if(!this.protocol.categories){
        this.$set(this.protocol, 'categories', []);
        this.addCategory();
      } else{
        
        this.protocol.categories = map(this.protocol.categories, (category, index) => {

          let tasksList = map(category.tasks, (task) => {

            let currentTaskIndex = findIndex(this.protocol.stages[0].tasks, function(item) {
              return item.globalUuid == task.uuid;
            });

            let currentMasteredTask = filter(this.protocol.stages[0].masteredTasks, function(item) {
              return item.globalUuid == task.uuid;
            });

            task.active = currentTaskIndex >= 0;
            task.mastered = currentMasteredTask.length == 1;
            if(currentTaskIndex >= 0){

              this.$set(this.protocol.stages[0].tasks[currentTaskIndex], 'mastered', currentMasteredTask.length == 1);
            }



            return task;
          });
          
         

          this.$set(this.protocol.categories[index], 'tasks', tasksList);
          this.$set(this.protocol.categories[index], 'active', !!filter(category.tasks, task => {return task.active}).length);

          if(!tasksList.length){
            this.$set(this.protocol.categories[index], 'active', true);
            this.addProperty(category.uuid, category.id)
          }


          return category;
        });


      }

    },

    methods: {

      removePropertyPopup: function(categoryUuid, taskUuid) {
        if (this.protocol.assigneeId && !this.protocol.isOnIndividualization) {
          this.currentCategoryUuid = categoryUuid;
          this.currentTaskUuid = taskUuid;
          this.isModalAcceptPopup = true;
        } else{
          this.removeProperty(categoryUuid, taskUuid)
        }
      },

      cancel: function() {
        this.isModalAcceptPopup = false;
        this.isModalAcceptPopupCategory = false;
      },

      removeCategoryPopup: function(categoryUuid) {
        if (this.protocol.assigneeId && !this.protocol.isOnIndividualization) {
          this.currentCategoryUuid = categoryUuid;
          this.isModalAcceptPopupCategory = true;
        } else{
          this.removeCategory(categoryUuid)
        }
      },

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

      changeActiveCategory(category){
        forIn(category.tasks, item => {
          item.active = category.active;

          this.changeActiveTask(category, item)

        });
      },

      changeActiveTask(category,currentTask){

        if (currentTask.active){

          let task = {
            'id': null,
            'globalTaskId': currentTask.id,
            'position': this.protocol.stages[0].tasks.length,
            'title': lang.get('protocol.property') + ' ' + this.protocol.stages[0].tasks.length,
            'description': currentTask.description,
            'isNew': true,
            'active': true,
            'uuid': UuidGenerator.v4(),
            'globalUuid': currentTask.uuid,
            'categoryUuid': currentTask.categoryUuid,
            'categoryId': currentTask.categoryId
          };

          this.protocol.stages[0].tasks.push(task);

        } else{
          let taskIndex = findIndex(this.protocol.stages[0].tasks,
              function(task) {
                return task.globalUuid === currentTask.uuid ;
              });

          if (taskIndex !== -1) {
            this.protocol.stages[0].tasks.splice(taskIndex, 1);
          }

        }


      },

      masteredTask(task){

        let taskCurrentIndex =  findIndex(this.protocol.stages[0].tasks, function(item) {
          return item.globalUuid == task.uuid;
        });

        if(taskCurrentIndex >= 0){
          console.info("mastered")

          this.$set(this.protocol.stages[0].tasks[taskCurrentIndex], 'mastered' , task.mastered);

        }

      },

      removeProperty: function(categoryUuid, taskUuid) {

        let currentCategoryIndex = findIndex(this.protocol.categories, category => {
          return category.uuid == categoryUuid;
        });

        let taskIndex = findIndex(this.protocol.categories[currentCategoryIndex].tasks,
          function(task) {
            return task.uuid === taskUuid;
          });

        if (taskIndex !== -1) {
          this.protocol.categories[currentCategoryIndex].tasks.splice(taskIndex, 1);

          forIn(this.protocol.stages, value => {
            let taskStageIndex;

            taskStageIndex =  findIndex(value.tasks,
              function(task) {
                return task.globalUuid === taskUuid;
              });

            value.tasks.splice(taskStageIndex, 1);
 

          });


        }


      },

      removeCategory: function(categoryUuid) {

        this.$emit('removed');

        let currentCategoryIndex = findIndex(this.protocol.categories, category => {
          return category.uuid == categoryUuid;
        });
        
        let currentTasks = this.protocol.categories[currentCategoryIndex].tasks;

        if (currentCategoryIndex !== -1) {
          
          this.protocol.categories.splice(currentCategoryIndex, 1);

          forIn(this.protocol.stages, (value, indexStages) => {

              remove(this.protocol.stages[indexStages].tasks, task => {
                return task.categoryUuid == categoryUuid;
              });

          });

        }

      },

      addProperty: function(categoryUuid, categoryId) {

        let uuid = UuidGenerator.v4();
        let currentCategoryIndex = findIndex(this.protocol.categories, category => {
          return category.uuid == categoryUuid;
        });
        
        let position = this.protocol.categories[currentCategoryIndex].tasks.length;

        this.protocol.categories[currentCategoryIndex].tasks.push( {
          'description': "",
          'id': null,
          'position': position,
          'protocolCategoryId': categoryId,
          'protocolCategoryUuid': categoryUuid,
          'title': lang.get('protocol.property') + ' ' + position,
          'uuid': uuid,
          'isNew': true,
          'active': true
        });


        forIn(this.protocol.stages, value => {

          let propertyPositon  = parseInt(value.tasks.length) + 1;

          this.$set(value.tasks, propertyPositon - 1, {
            'id': null,
            'globalTaskId': null,
            'position': propertyPositon,
            'title': lang.get('protocol.property') + ' ' + propertyPositon,
            'description': '',
            'isNew': true,
            'active': true,
            'uuid': UuidGenerator.v4(),
            'globalUuid': uuid,
            'categoryUuid': categoryUuid,
            'categoryId': categoryId
          });

        });

      },

      addCategory(){

        let uuid = UuidGenerator.v4().toString();

        this.protocol.categories.push({
          'id': null,
          'uuid': uuid,
          'currentStage': {
            id: this.protocol.stages[0].id,
            uuid: this.protocol.stages[0].uuid,
            description: this.protocol.stages[0].description,
            hasAssignedStage: false,
            isClosed: false,
          },
          'tasks': [],
          'title': '',
          'masteringPercent': 0,
          'active': true,
          'typeId': 1
        });

        this.addProperty(uuid, null);

      }

    },


  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/CriteriaPecsItems.vue